import {css} from '@emotion/react'
import {OpenAIOutlined} from '@ant-design/icons'
import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import {useSecondarySideBarContext} from '../../SecondarySideBar.jsx'
import AiAgent from '../../sideBars/AiAgent/AiAgent.jsx'
import MenuButton from '../MenuButton.jsx'

const MapType2AgentCode = {
    _BD_MAP: 'BD_AGENT',
}

const cssButton = css({
    aspectRatio: 1,
    padding: 0,
})

export default function MenuButtonAiAgent(props) {
    const filterByLicense = useFilterByLicense()
    const [ssb, setSsb] = useSecondarySideBarContext()
    const map = useMapContext()
    map.usePermission()

    if (! map.permission.has('write')) {
        return null
    }

    const {mapTypeCode} = map.data
    const agentCode = MapType2AgentCode[mapTypeCode]

    if (! agentCode) {
        return null
    }

    const onClick = () => {
        if (ssb) {
            setSsb(null)
        }
        else {
            setSsb(
                <AiAgent
                    agentCode={agentCode}
                    map={map}
                />
            )
        }
    }

    return filterByLicense('M00040001',
        <MenuButton
            css={cssButton}
            title="AI助手"
            onClick={onClick}
            {...props}
        >
            <OpenAIOutlined />
        </MenuButton>
    )
}
